/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Beer',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <g fill="currentColor">
            <path
              fillRule="evenodd"
              d="M18.444 6.483a2.6 2.6 0 0 1 2.6 2.6v5.503a2.6 2.6 0 0 1-2.6 2.601H17.1v1.151a3.6 3.6 0 0 1-3.601 3.6H6.667a3.6 3.6 0 0 1-3.6-3.6V7.083a.6.6 0 0 1 .6-.6.6.6 0 0 1 .6.6v11.255a2.4 2.4 0 0 0 2.4 2.4H13.5a2.4 2.4 0 0 0 2.4-2.4V7.083a.6.6 0 0 1 .6-.6h1.944zM17.1 15.986h1.344a1.4 1.4 0 0 0 1.4-1.4V9.083a1.4 1.4 0 0 0-1.4-1.4H17.1v8.304z"
            />
            <path d="M6.876 9.823a.6.6 0 0 1 .6.601v6.476a.6.6 0 0 1-.6.601.6.6 0 0 1-.6-.601v-6.476a.6.6 0 0 1 .6-.601z" />
            <use href="#B" />
            <use
              href="#B"
              x="3.207"
            />
            <path
              fillRule="evenodd"
              d="M15.178 2.063c1.123 0 2.033.911 2.033 2.034s-.91 2.033-2.033 2.033h-1.234c-.163 0-.296.133-.296.296a2.28 2.28 0 0 1-2.277 2.276 2.28 2.28 0 0 1-2.277-2.276c0-.143-.101-.262-.236-.29l-.06-.006H4.99c-1.123 0-2.033-.911-2.033-2.033s.91-2.034 2.033-2.034h10.188zM4.99 3.263c-.431 0-.787.328-.829.749l-.004.085c0 .46.373.833.833.833h3.808c.774 0 1.412.589 1.488 1.343l.008.153c0 .594.482 1.076 1.077 1.076.558 0 1.016-.424 1.071-.967l.006-.109c0-.826.67-1.496 1.496-1.496h1.234c.431 0 .786-.328.829-.748l.004-.085c0-.432-.328-.787-.748-.83l-.085-.004H4.99z"
            />
          </g>
          <defs>
            <path
              id="B"
              d="M10.085 9.823a.6.6 0 0 1 .6.601v6.476a.6.6 0 1 1-1.2 0v-6.476a.6.6 0 0 1 .601-.601z"
            />
          </defs>
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
